import React, { Component } from 'react';
import './css/overlay.css';  // Import your CSS file
import Path from '../../images/filter_arrow.svg';
import Filter from '../../images/filter_icon.svg';

class Overlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true, // Initial state of the overlay (closed)
      zoomLevel: 1, // Initial zoom level (assuming no zoom)
    };
  }

  componentDidMount() {
    // Detect zoom level when component is mounted
    this.detectZoom();
    // Add event listener to track zoom level changes
    window.addEventListener('resize', this.detectZoom);
  }

  componentWillUnmount() {
    // Clean up event listener when component is unmounted
    window.removeEventListener('resize', this.detectZoom);
  }

  // Function to detect zoom level using devicePixelRatio
  detectZoom = () => {
    const zoom = window.devicePixelRatio || 1; // Get zoom level
    this.setState({ zoomLevel: zoom });
  };

  toggleOverlay = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen, // Toggle the overlay's state
    }));
  };

  render() {
    const { isOpen, zoomLevel } = this.state;
    const buttonIcon = isOpen ? Path : Filter; // Toggle button icon
    
    // Define different scaling for different zoom levels
    let zoomStyles = {};
    let overlayWidth = '21vw'; // Default overlay width (no zoom)
    let overlayHeight = '95vh';
    let overlayConstantWidth = '19vw';
    let imageWidth = '100%';
    let closeImageWidth = '100%';
    let imageOpenPadding = '12px';
    let rightSpacing = '21%';
    let topSpacing = '10%'

    if (zoomLevel >= 1.5) {
      zoomStyles = { transform: 'scale(1.5)', transition: 'transform 0.3s ease', top: '10%' };
      overlayWidth = '23vw'; // Adjust overlay width for 150% zoom
      overlayHeight = '98vh';
       imageWidth = '60%';
       imageOpenPadding = '3px';
       rightSpacing = '23%';
       topSpacing = '9%'
    } else if (zoomLevel >= 1.25) {
      zoomStyles = { transform: 'scale(1.25)', transition: 'transform 0.3s ease', top: '7%' };
      overlayWidth = '21vw'; // Adjust overlay width for 125% zoom
       overlayHeight = '95vh';
        imageWidth = '90%';
        imageOpenPadding = '8px';
        rightSpacing = '21%';
        topSpacing = '10%'

    } else if (zoomLevel > 1.1) {
      zoomStyles = { transform: 'scale(1.1)', transition: 'transform 0.3s ease' };
      overlayWidth = '21vw'; // Adjust overlay width for 110% zoom
       overlayHeight = '95vh';
       imageWidth = '100%';
       imageOpenPadding = "12px";
       rightSpacing = '21%';
       topSpacing = '10%'
    }

    return (
      <div className="overLaycontainer">
        {/* Overlay Button */}
        <button
          className={`overlay-button ${isOpen ? 'move-button' : ''}`}
          id= {isOpen ? "overlay_button_id" : "overlay_button_id"}
          onClick={this.toggleOverlay}
          style={{ borderRadius: '0px', ...zoomStyles, padding: imageOpenPadding , right: isOpen ? rightSpacing : '', top: isOpen ? topSpacing : '9%'  }} // Apply dynamic styles based on zoom
        >
          <span role="img" aria-label="icon">
            <img style={{width: imageWidth}} src={buttonIcon} alt="Toggle Icon" />
          </span>
        </button>

        {/* Overlay */}
        <div
          className={`overlay ${isOpen ? 'open' : ''}`}
          style={{ width: isOpen ? overlayWidth: overlayConstantWidth, height: overlayHeight }} // Adjust overlay width dynamically
        >
          <div className="overlay-content">
            {this.props.children} {/* Dynamic content */}
          </div>
        </div>
      </div>
    );
  }
}

export default Overlay;